import { useQuery } from '@tanstack/react-query';

import { fetchDosespotPatientInfoByUserId } from '../api/getDosespotPatientInfoByUserId.js';
import { rxKeys } from './keys.js';

export interface DosespotPatientInfoQueryOptions {
  toastOnError?: boolean;
  sentryOnError?: boolean;
}

export function dosespotPatientInfoQueryDefinition(
  userId: string,
  options: DosespotPatientInfoQueryOptions = {}
) {
  return {
    queryKey: rxKeys.dosespotPatientInfo(userId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchDosespotPatientInfoByUserId(userId, signal),
    meta: {
      toast: {
        title: 'Could not load DoseSpot patient info',
        description: 'DoseSpot patient info could not be fetched.',
      },
      ...(options.toastOnError === false ? { toastOnError: false } : {}),
      ...(options.sentryOnError === false ? { sentryOnError: false } : {}),
    },
  } as const;
}

export function useDosespotPatientInfoQuery(
  userId: string | undefined,
  options: DosespotPatientInfoQueryOptions = {}
) {
  return useQuery({
    ...dosespotPatientInfoQueryDefinition(userId ?? '', options),
    enabled: !!userId,
  });
}
